
const digest = '756d8c98447d3d07ff17ed4961d66df15dfe113207daac714afa37970c195f06';
const classes = {"wrapper":"_wrapper_1lpos_1"};
const css = `._wrapper_1lpos_1 {
  position: absolute;
  top: -30px;
  right: 0;
  display: flex;
  justify-content: flex-end;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  